import * as tf from '@tensorflow/tfjs'

export const trainPoseModel = async ({
    modelData,
    camModels,
    setModelDetails,
}) => {
    console.log('=== POSE DISTRIBUTION ===')
    console.log('model: ',modelData, 'camModels:', camModels, 'setModelDetails:', setModelDetails)
    Object.values(modelData.ImageClasses).forEach((c) => {
        console.log(
            c.className,
            'poses:',
            c.capturedPoses?.length,
            'images:',
            c.capturedImages?.length
        )
    })
    const classes = modelData.ImageClasses

    let inputs = []
    let outputs = []
    let CLASS_NAMES = []
    let count = 0

    for (let key in classes) {
        const eachClass = classes[key]

        if (!eachClass.capturedPoses?.length) continue

        CLASS_NAMES.push(eachClass.className)

        eachClass.capturedPoses.forEach((sample) => {
            console.log('Sample', sample.poseVector)
            if (
                !sample?.poseVector ||
                !Array.isArray(sample.poseVector) &&
                !(sample.poseVector instanceof Float32Array)
            ) {
                return
            }
            inputs.push(sample.poseVector)
            outputs.push(count)
        })
        count++
    }

    if (CLASS_NAMES.length < 2) return

    tf.util.shuffleCombo(inputs, outputs)

    const cleanInputs = []
    const cleanOutputs = []

    console.log('Total raw inputs:', inputs.length, 'labels:', outputs.length)

    // Feature length is not fixed: pose vectors are 34 (17 keypoints x2) and
    // hand-gesture vectors are 42 (21 landmarks x2). Determine the dominant
    // length from the data and keep only vectors that match it, so a model that
    // switched types (and has stale mixed vectors) still trains cleanly.
    const lengthCounts = {}
    inputs.forEach((vec) => {
        if (!vec) return
        const len = (vec.length || Array.from(vec).length) | 0
        if (len) lengthCounts[len] = (lengthCounts[len] || 0) + 1
    })
    const expectedLen = Number(
        Object.keys(lengthCounts).sort(
            (a, b) => lengthCounts[b] - lengthCounts[a]
        )[0]
    )

    inputs.forEach((vec, i) => {
        if (!vec) return

        const arr = Array.from(vec)

        if (!Array.isArray(arr) || arr.length !== expectedLen) {
            console.warn('Skipping bad vector:', arr?.length)
            return
        }

        cleanInputs.push(arr)
        cleanOutputs.push(outputs[i])
    })

    console.log('Cleaned inputs:', cleanInputs.length, 'labels:', cleanOutputs.length)
    if (cleanInputs.length === 0) {
        throw new Error('No valid pose data found')
    }

    //shuffle AFTER cleaning
    tf.util.shuffleCombo(cleanInputs, cleanOutputs)

    // SAFE tensor creation
    const xs = tf.tensor2d(cleanInputs, [
        cleanInputs.length,
        cleanInputs[0].length,
    ])

    const labelsTensor = tf.tensor1d(cleanOutputs, 'int32')
    const ys = tf.oneHot(labelsTensor, CLASS_NAMES.length)

    const model = tf.sequential()

    model.add(
        tf.layers.dense({
            inputShape: [cleanInputs[0].length],
            units: 128,
            activation: 'relu',
        })
    )

    model.add(
        tf.layers.dense({
            units: 64,
            activation: 'relu',
        })
    )

    model.add(
        tf.layers.dense({
            units: CLASS_NAMES.length,
            activation: 'softmax',
        })
    )

    model.compile({
        optimizer: tf.train.adam(0.001),
        loss: 'categoricalCrossentropy',
        metrics: ['accuracy'],
    })

    await model.fit(xs, ys, {
        epochs: modelData.epochs,
        batchSize: modelData.batchSize,
        shuffle: true,
    })

    const saveKey = modelData.saveKey || modelData.modelId
    await model.save(`indexeddb://${saveKey}`)

    xs.dispose()
    ys.dispose()
    labelsTensor.dispose()
    model.dispose()
    let updatedModels = [...camModels]
    const index = updatedModels.findIndex(
        (m) => m.modelId === modelData.modelId
    )

    if (index !== -1) {
        const type = modelData.trainedType || 'pose'
        updatedModels[index].isGenerateTensor = true
        updatedModels[index].classLabels = CLASS_NAMES
        updatedModels[index].trainedTypes = {
            ...(updatedModels[index].trainedTypes || {}),
            [type]: true,
        }
    }

    setModelDetails(updatedModels)
}
